import * as types from './_actionTypes';

export const fetchAdminStatsRequest = () => ({
  type: types.FETCH_ADMIN_STATS_REQUEST
});

export const fetchAdminStatsSuccess = (stats) => ({
  type: types.FETCH_ADMIN_STATS_SUCCESS,
  payload: stats
});

export const fetchAdminStatsFailure = (error) => ({
  type: types.FETCH_ADMIN_STATS_FAILURE,
  payload: error
});

export const fetchRecentActivitiesRequest = () => ({
  type: types.FETCH_RECENT_ACTIVITIES_REQUEST
});

export const fetchRecentActivitiesSuccess = (activities) => ({
  type: types.FETCH_RECENT_ACTIVITIES_SUCCESS,
  payload: activities
});

export const fetchRecentActivitiesFailure = (error) => ({
  type: types.FETCH_RECENT_ACTIVITIES_FAILURE,
  payload: error
});